import React from "react";

const skillsCategories = [
  {
    title: "FRONTEND",
    icon: "fa fa-laptop",
    color: "#6b4ce6", // Purple
    bg: "rgba(107, 76, 230, 0.15)",
    skills: [
      { name: "⚛️ React.js" },
      { name: "▲ Next.js" },
      { name: "🔷 TypeScript" },
      { name: "⚡ JavaScript" }
    ]
  },
  {
    title: "BACKEND",
    icon: "fa fa-server",
    color: "#21c55e", // Green
    bg: "rgba(33, 197, 94, 0.15)",
    skills: [
      { name: "🟩 Node.js" },
      { name: "⚡ Express" },
      { name: "⚡ gRPC" },
      { name: "🔌 WebSockets" },
    ]
  },
  {
    title: "DATABASE",
    icon: "fa fa-database",
    color: "#f97316", // Orange
    bg: "rgba(249, 115, 22, 0.15)",
    skills: [
      { name: "🐘 PostgreSQL" },
      { name: "🍃 MongoDB" },
      { name: "⚡ Redis" },
      { name: "🐬 MySQL" },
    ]
  },
  {
    title: "DEVOPS & CLOUD",
    icon: "fa fa-cloud",
    color: "#c026d3", // Pink/Purple
    bg: "rgba(192, 38, 211, 0.15)",
    skills: [
      { name: "☁️ AWS" },
      { name: "🪣 S3 Bucket" },
      { name: "🐳 Docker" },
      { name: "⚙️ CI/CD" }
    ]
  },
  {
    title: "AI INTEGRATION",
    icon: "fa fa-magic",
    color: "#9333ea", // Deep Purple
    bg: "rgba(147, 51, 234, 0.15)",
    skills: [
      { name: "🤖 OpenAI" },
      { name: "✨ Gemini" },
      { name: "📝 Claude" },
      { name: "🧠 LLM" },
    ]
  },
  {
    title: "Tools & SDKs",
    icon: "fa fa-gears",
    color: "#9333ea", // Deep Purple
    bg: "rgba(147, 51, 234, 0.15)",
    skills: [
      { name: "📹 Agora" },
      { name: "🔌 WebSockets" },
      { name: "⚡ OAuth2" },
      { name: "💳 Stripe" },
    ]
  }
];

const Skills = () => {
  return (
    <div className="row skills-container">
      {skillsCategories.map((category, i) => (
        <div className="col-12 col-md-6 col-lg-4 mb-4" key={i}>
          <div className="skill-category-card">
            <div className="category-header">
              <div
                className="icon-box"
                // style={{ backgroundColor: category.bg, color: category.color }}
                style={{ color: "#72b626", backgroundColor: "rgba(33, 197, 94, 0.15)" }}
              >
                <i className={category.icon}></i>
              </div>
              <h5 style={{ color: "#72b626" }}>{category.title}</h5>
            </div>

            <div className="category-body">
              {category.skills.map((skill, index) => (
                <div className="skill-pill" key={index}>
                  <span>{skill.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Skills;
